import { isMockMode, post, simulateDelay } from "../api";

export const updateService = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Services/Update`, data, {
		successMessage: "Service successfully updated",
	});
};
